import "./Record.scss";
import { useNavigate, useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { database } from "../firebaseConfig";
import { useState, useEffect } from "react";
import v_logo from "../Assets/veligaa-logo.png";

function Record() {
  const [companyLogo, setCompanyLogo] = useState(null);
  const [promoLogo, setPromoLogo] = useState(null);
  const [prizes, setPrizes] = useState([
    {
      name: "",
      limit: null,
      winners: [], // Initialize winners array as empty array
    },
  ]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedTextColor, setSelectedTextColor] = useState(null);
  const navigate = useNavigate();
  const { title } = useParams();

  const fetchDrawData = async () => {
    try {
      const drawDataRef = doc(database, "Promotions", title);
      const docSnapshot = await getDoc(drawDataRef);
      const data = docSnapshot.data();
      if (data) {
        setCompanyLogo(data.companyLogo);
        setPromoLogo(data.promoLogo);
        setSelectedImage(data.selectedImage);
        setSelectedTextColor(data.selectedTextColor);
        setPrizes(data.prizes);
        // console.log(data.prizes);
        console.log(prizes);
      }
    } catch (error) {
      console.error("Error fetching draw data:", error);
    }
  };

  useEffect(() => {
    if (title) {
      fetchDrawData();
    }
  }, [title]);

  const navigateToCreate = () => {
    navigate("/");
  };

  //   const navigateToDraw = () => {
  //     navigate("/draw", {
  //       state: {
  //         title,
  //         companyLogo,
  //         promoLogo,
  //         limit,
  //         selectedImage,
  //         selectedTextColor,
  //       },
  //     });
  //   };

  //   const navigateToPrevious = () => {
  //     navigate("/previous");
  //   };

  return (
    <div
      className="record"
      // style={{ backgroundImage: `url(${selectedImage})` }}
    >
      <div className="navButtons">
        {/* <button
          className="create"
          // style={{ color: selectedTextColor }}
          onClick={navigateToCreate}
        >
          Create
        </button> */}
        {/* <button
          className="Draw"
          style={{ color: selectedTextColor }}
          onClick={navigateToDraw}
        >
          Draw
        </button>
        <button
          className="Previous"
          style={{ color: selectedTextColor }}
          onClick={navigateToPrevious}
        >
          Previous Draws
        </button> */}
      </div>

      <div
        className="records-content"
        // style={{ color: selectedTextColor }}
      >
        <div className="logoContainer">
          <div className="c-logo">
            <img src={v_logo} alt="" className="logo" />
          </div>
          <div className="p-logo">
            <img src={promoLogo} alt="" className="promoLogo" />
          </div>
        </div>
        <h1 className="promoTitle">{title}</h1>

        <div className="winners">
          {prizes !== null ? (
            <span className="winner-grid">
              {prizes.map((item, index) => (
                <span key={index} className="prize-group">
                  <h1>{item.name}</h1>
                  <ul>
                    {item.winners.map((winner, index) => (
                        <li key={index}>
                          {winner.customerName} - {winner.couponCode}
                        </li>
                    ))}
                  </ul>
                </span>
              ))}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default Record;
